<script lang="ts">
	import { slide } from 'svelte/transition'
	import EmailSpellcheck from '../checkout_email_spellcheck/EmailSpellcheck.svelte'
	import CustomAddToCart from 'shared/component/CustomAddToCart.svelte'

	export let product_ref: string | number

	const min = 5
	const max = 500
	const presets = [ 25, 50, 100, 150 ]
	let amount = `25.00`

	let send_to_someone_else = false
	let recipient_email = ``
	let message = ``
	let sender_name = ``

	// if you click the number spinner, the input will be focused
	function focus_if_not_focused(event: any) {
		if (event.target && event.target !== document.activeElement) {
			event.target.focus()
		}
	}

	let recipient_email_input: HTMLInputElement
</script>

<div class="row">
	<label for="amount">Amount</label>
	<div class="button-row">
		{#if presets.length}
			{#each presets as n}
				<button type="button" class="input-text" on:click={() => { amount = n.toFixed(2) }} data-chosen={n === Number(amount)}>
					${n.toFixed(2).replace(`.00`, ``)}
				</button>
			{/each}
		{/if}
		<input type="number" {min} {max} step={0.01} name="amount" bind:value={amount} on:change={focus_if_not_focused} required data-valid={min <= Number(amount) && Number(amount) <= max} />
	</div>
</div>
<div class="row">
	<label for="">Recipient</label>
	<div class="button-row">
		<button type="button" class="input-text" on:click={() => { send_to_someone_else = false }} data-chosen={send_to_someone_else === false}>
			Myself
		</button>
		<button type="button" class="input-text" on:click={() => { send_to_someone_else = true }} data-chosen={send_to_someone_else === true}>
			Someone else
		</button>
	</div>
</div>
{#if send_to_someone_else}
	<div transition:slide>
		<div class="row">
			<label for="email">Email</label>
			<div>
				<input type="email" name="email" bind:value={recipient_email} bind:this={recipient_email_input} />
				<div><EmailSpellcheck input={recipient_email_input} /></div>
			</div>
		</div>
		<div class="row">
			<label for="message">Message</label>
			<div><textarea name="message" bind:value={message}></textarea></div>
		</div>
		<div class="row">
			<label for="sender_name">Your name</label>
			<div><input type="text" name="sender_name" bind:value={sender_name} /></div>
		</div>
	</div>
{/if}
<div class="add-to-cart">
	<CustomAddToCart
		configured_price={null}
		product_title={`Gift Card`}
		cart_endpoint={`/item/add_gift_card`}
		shopping_cart_object={{
			product_ref,
			amount,
			personalization: send_to_someone_else
				? { recipient_email, message, sender_name }
				: {},
		}}
		disable_add_to_cart={!amount || (send_to_someone_else && !recipient_email)}
		product_ref={product_ref}
		max_quantity={1}
		left_align={false}
	></CustomAddToCart>
</div>
<div style="clear: both;"></div>

<style>
	div {
		--contrast-gray: #b3b3b3;
	}
	.row {
		display: flex;
	}
	.row > div {
		padding: 8px;
		width: 100%;
	}
	label {
		padding: 16px 8px;
		display: inline-block;
		min-width: 110px;
		font-size: 14px;
		font-weight: bold;
		text-transform: uppercase;
		color: var(--contrast-gray);
	}
	.button-row {
		display: flex;
		flex-direction: row;
		gap: 10px;
		flex-wrap: wrap;
		align-items: center;
	}
	button[type="button"] {
		padding: 10px;
		text-transform: none;
	}
	[data-chosen="true"] {
		outline: 3px solid #fff;
	}
	[data-valid="false"]:not(:focus) {
		outline: 3px solid #f00;
	}
	input[type="email"],
	input[type="text"],
	textarea {
		width: 100%;
	}
	.add-to-cart {
		margin: 8px;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 8px;
	}
</style>
